<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input  :disabled="this.model.id"   v-decorator="[ 'ip', validatorRules.ip]" placeholder="请输入地址"></a-input>
        </a-form-item>
        <a-form-item label="系统类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-dict-select-tag dictCode="bus_server_sys_type" placeholder="请输入选择类型" v-decorator="[ 'sysType', validatorRules.sysType]" :trigger-change="true"></j-dict-select-tag>
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'sort', validatorRules.sort]" placeholder="请输入排序" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch  v-decorator="[ 'izActivity', validatorRules.izActivity]"   checkedChildren="启用"   unCheckedChildren="禁用" ></a-switch>
        </a-form-item>
        <!-- <a-form-item label="启动步骤" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-editor :key="editorKey" v-decorator="['startStep',{trigger:'input'}]"/>
        </a-form-item> -->
        
        <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input     v-decorator="[ 'username', validatorRules.username]" placeholder="请输入用户名"></a-input>
        </a-form-item>
        <a-form-item label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input type="password"  v-decorator="[ 'password', validatorRules.password]" placeholder="请输入密码"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remarks', validatorRules.remarks]" placeholder="请输入备注"></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JEditor from '@/components/jeecg/JEditor'
  export default {
    name: "BusServermanageServersModal",
    components: { 
      JEditor

    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          ip: {rules: [
            {required: true, message: '请输入地址!'},
            { validator: (rule, value, callback) => validateDuplicateValue('bus_servermanage_servers', 'ip', value, this.model.id, callback)},
          ]},
          sysType: {rules: [
          ]},
          sort: {rules: [
          ]},
          izActivity: {rules: [
          ] ,valuePropName: 'checked'},
          remarks: {rules: [
          ]},
          // startStep: {rules: [
          // ]},
          username: {rules: [
          ]},
          password: {rules: [
          ]},
        },
        url: {
          add: "/servermanage/busServermanageServers/add",
          edit: "/servermanage/busServermanageServers/edit",
        },
        editorKey:new Date().valueOf()
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({izActivity:1});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.model.izActivity=(record.izActivity===1)?true:false
        this.visible = true;
        this.$nextTick(() => {
          this.editorKey=new Date().valueOf()
          this.form.setFieldsValue(pick(this.model,'ip','sysType','sort','izActivity','username','password','remarks'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            values.izActivity=values.izActivity?1:0;
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'ip','sysType','sort','izActivity','remarks'))
      },

      
    }
  }
</script>